import { render, staticRenderFns } from "./CiSwitch.vue?vue&type=template&id=032aa675&scoped=true&"
import script from "./CiSwitch.vue?vue&type=script&lang=js&"
export * from "./CiSwitch.vue?vue&type=script&lang=js&"
import style0 from "./CiSwitch.vue?vue&type=style&index=0&id=032aa675&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "032aa675",
  null
  
)

component.options.__file = "CiSwitch.vue"
export default component.exports